import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ButtonGroup from '@mui/material/ButtonGroup';
import ReplyIcon from '@mui/icons-material/Reply';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import api, { authHeader } from '../../../../../../../services/API/apiConfig';

import { RootStyled, ResponseBtn, ActionsBtn } from './styles';

export default function ResponseButtons({
  responding,
  setResponding,
  handleSubmit,
  files,
}) {
  const navigate = useNavigate();
  const { id: ticketId } = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleResponding = async (data) => {
    if (responding) {
      const formData = new FormData();
      formData.append('rich_text', data.response);
      formData.append('raw_content', data.response);
      files.forEach((file) => {
        formData.append(
          'feedback_attachments_attributes[][attachment_file]',
          file
        );
      });

      try {
        await api.post(`/feedbacks/${ticketId}/feedback_messages`, formData, {
          headers: authHeader(true),
        });
        await api.patch(
          `/feedbacks/${ticketId}`,
          { read_by_user: false },
          { headers: authHeader() }
        );
      } catch (err) {
        console.log(err);
      }
      navigate('/support');
    }
    setResponding((prev) => !prev);
  };

  const handleStatusChange = async (status) => {
    try {
      await api.patch(
        `/feedbacks/${ticketId}`,
        { status },
        {
          headers: authHeader(),
        }
      );
      navigate('/support');
    } catch (err) {
      console.log(err);
    }
    handleClose();
  };

  return (
    <RootStyled>
      <ButtonGroup variant="contained" sx={{ borderRadius: 2 }}>
        <ResponseBtn
          onClick={handleSubmit(handleResponding)}
          startIcon={<ReplyIcon />}
        >
          {responding ? 'Enviar' : 'Responder'}
        </ResponseBtn>
        <ActionsBtn
          aria-controls={open ? 'status-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <ExpandMoreIcon />
        </ActionsBtn>
      </ButtonGroup>
      <Menu
        id="status-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleStatusChange('closed')}>
          <CancelIcon sx={{ mr: 1 }} /> Encerrado
        </MenuItem>
        <MenuItem onClick={() => handleStatusChange('closed')}>
          <CheckCircleIcon color="success" sx={{ mr: 1 }} /> Resolvido
        </MenuItem>
      </Menu>
    </RootStyled>
  );
}
